import serverCall from "../../serverCall";

const CreateSeasons = async (data) => {
  const response = await serverCall.post(`/season/admin/create`, data);
  return response;
};

const createSeasonsList = async (data) => {
  const response = await serverCall.post(`/season/admin/createList`, data);
  return response;
};

const getAllSeasons = async (page, size, season, search, type) => {
  const response = await serverCall.get(
    `/season/admin/all?page=${page}&size=${size}&season=${season}&search=${search}&type=${type}`
  );
  return response;
};

const getAllSeasonsList = async (page, size, type) => {
  const response = await serverCall.get(
    `/season/admin/allList?page=${page}&size=${size}&type=${type}`
  );
  return response;
};

const deleteAllSeasonsData = async (id) => {
  const response = await serverCall.delete(`/season/admin?seasonId=${id}`);
  return response;
};

const deleteSeasonsList = async (id) => {
  const response = await serverCall.delete(
    `/season/admin/seasonList?seasonId=${id}`
  );
  return response;
};


const UpdateSeasonsList = async (data) => {
  const response = await serverCall.patch(
    `/season/admin/updateList`, data
  );
  return response;
};

const SeasonsService = {
  CreateSeasons,
  getAllSeasons,
  getAllSeasonsList,
  createSeasonsList,
  deleteAllSeasonsData,
  deleteSeasonsList,
  UpdateSeasonsList
};

export default SeasonsService;
